import type {ReactElement} from 'react';
import React from 'react';
import {GoogleMap} from '@Components/google-map';
import {Button, Size, Type} from '@Components/button';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {useDispatch} from 'react-redux';
import useCustomPanelClose from '@Panels/hooks/useCustomPanelClose';
import styles from './google-map-selector-panel-content.module.scss';
import type {GoogleMapSelectorPanelContentProps} from './google-map-selector-panel-content.types';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';

export function GoogleMapSelectorPanelContent({
  googleMapAPIKey,
  isMobile,
  onLocationChange,
  selectorPanelCTAOptions,
  defaultSelectedLocation = undefined,
}: GoogleMapSelectorPanelContentProps): ReactElement {
  const dispatch = useDispatch();

  const onModalClose = (): void => {
    if (selectorPanelCTAOptions) {
      dispatch(closeModal(selectorPanelCTAOptions.modalId));
    }
  };

  const getCTAOptionsContent = (): ReactElement | undefined => {
    if (!selectorPanelCTAOptions) {
      return undefined;
    }

    const selectedVenuePanelClose = useCustomPanelClose(selectorPanelCTAOptions.panelId, selectorPanelCTAOptions.onSelectedVenuePanelClose);

    return (
      <div className={`flex-row-align-center justify-content-end ${isMobile ? 'spacing-p-b-4' : 'spacing-p-b-6'}`}>
        {selectorPanelCTAOptions.showCloseOption ? (
          <Button onClick={onModalClose} customClasses="spacing-m-r-3" type={Type.SECONDARY} size={Size.MEDIUM} text={window.i18next.t('pmwjs_cancel')} />
        ) : undefined}
        <Button
          disabled={!selectorPanelCTAOptions?.isLocationSelected}
          onClick={selectedVenuePanelClose}
          type={Type.PRIMARY}
          size={Size.MEDIUM}
          text={window.i18next.t('pmwjs_done')}
        />
      </div>
    );
  };

  return (
    <>
      <div className={`${isMobile ? 'spacing-p-t-4 spacing-p-b-4' : 'spacing-p-t-6 spacing-p-b-6'} _full-width`}>
        <GoogleMap
          googleMapAPIKey={googleMapAPIKey}
          onLocationChange={onLocationChange}
          isViewOnly={false}
          defaultLocation={defaultSelectedLocation}
          selectCurrentLocationAsDefault={!defaultSelectedLocation}
          autocompleteInputFieldSize={InputFieldSize.SMALL}
          mapStyle={{
            className: `${styles.map} spacing-m-t-6`,
            isRoundedBorder: true,
          }}
        />
      </div>
      {getCTAOptionsContent()}
    </>
  );
}
